import { KBDocument } from '../../types';

export const stressAndDigestion: KBDocument = {
  id: 'placeholder-stress-digestion',
  title: '[PLACEHOLDER] Stress and digestive symptoms — general background',
  source: 'Placeholder demo content — not yet curated',
  placeholder: true,
  text: `The gut and the nervous system are closely linked, and periods of high stress are commonly
reported alongside digestive symptoms such as nausea, bloating, and changes in appetite. People
who track symptoms over time sometimes notice their digestive symptoms cluster around
particularly stressful days or weeks.

General stress-management habits — such as regular meal timing, brief breaks during demanding
periods, and basic relaxation techniques — are often mentioned as supportive self-care measures.
This is general background information, not a diagnosis or treatment recommendation for any
individual, and persistent digestive symptoms should be discussed with a healthcare provider.`
};
